import { Component } from '@angular/core';

@Component({
  selector: 'shared-table-container',
  standalone: true,
  templateUrl: './table-container.component.html',
  styleUrls: ['./table-container.component.css']
})
export class TableContainerComponent {

}
